import * as yup from "yup"

// Vars
const reminder_validation = {
  memo: yup.string().label("Memo").required(),
  promise_date: yup.string().label("Promised Date").required(),
  transaction_date: yup.string().label("Date").required()
}

export const detail_validation_schema = yup.object().shape({
  bill_detail_id: yup.number().optional(),
  discount: yup.number().label("Discount").required(),
  mr_unit_id: yup.string().label("Unit").required(),
  price_bill: yup.number().label("Price").required(),
  product_id: yup.string().label("Item Order").required(),
  project_id: yup.string().label("Jobs").required(),
  quantity_bill: yup.number().label("Qty Bill").min(1).required(),
  quantity_unit: yup.number().label("Qty Unit").min(1).required(),
  tax_id: yup.string().label("Tax").required(),
  total: yup.number().label("Total").required(),
  quantity_unit_convention:yup.number().optional(),
  //delivered: yup.number().label("Total").required(),
  description: yup.string().label("Description"),
  vendor_description: yup.string().optional(),
})
export const reminder_validation_schema = yup.object().shape(reminder_validation)
export const validation_schema = yup.object().shape({
  bill_id:yup.number().optional(),
  purchase_order_id:yup.number().optional(),
  trx_code: yup.string().defined(),
  _vendor_name: yup.string().defined(),
  approval_status: yup.number().defined(),
  address: yup.string().label("Address").optional(),
  freight: yup.number().label("Freight").required(),
  location_id: yup.string().label("Location").required(),
  memo: yup.string().label("Memo").required(),
  payment_term: yup.string().label("Trading Term").required(),
  promise_date: yup.string().label("Promised Date").required(),
  referensi: yup.string().label("Referensi").required(),
  tax_inclusive: yup.boolean().label("Tax Inclusive").required(),
  transaction_date: yup.string().label("Date").required(),
  vendor_id: yup.string().label("Supplier").required(),
  reminder: yup.object().nullable().shape(reminder_validation),
  probildetail: yup.array().label("Bill Detail").min(1).required().of(detail_validation_schema),
  imgPath: yup.array().of(yup.object().shape({
    file_path: yup.string().required(),
  })).label("FILE").min(0).optional(),
  delivery_no:yup.number().optional().defined().default(0),
})

export type FormType = yup.InferType<typeof validation_schema>
export type DetailFormType = yup.InferType<typeof detail_validation_schema>
export type ReminderFormType = yup.InferType<typeof reminder_validation_schema>